export enum WalletErrors {
    MISSING_WALLET_FIELDS = 'MISSING_WALLET_FIELDS',
    INVALID_WALLET_FIELDS = 'INVALID_WALLET_FIELDS',
    WALLET_PROCESSING_FAILURE = 'WALLET_PROCESSING_FAILURE',
    WALLET_EXPIRED = 'WALLET_EXPIRED',
    WALLET_DUPLICATE_PAYMENT_METHODS = 'WALLET_DUPLICATE_PAYMENT_METHODS',
    WALLET_PAYMENT_NOT_ENABLED = 'WALLET_PAYMENT_NOT_ENABLED',
    DUPLICATE_WALLET_RESOURCE = 'DUPLICATE_WALLET_RESOURCE',
    WALLET_CLIENT_KEY_FAILURE = 'WALLET_CLIENT_KEY_FAILURE',
    INVALID_WALLET_PAYMENT_DATA = 'INVALID_WALLET_PAYMENT_DATA',
    WALLET_ONBOARDING_ERROR = 'WALLET_ONBOARDING_ERROR',
    WALLET_MISSING_DOMAIN = 'WALLET_MISSING_DOMAIN',
    WALLET_UNREGISTERED_DOMAIN = 'WALLET_UNREGISTERED_DOMAIN',
    WALLET_CHECKOUT_CANCELED = 'WALLET_CHECKOUT_CANCELED',
    USER_NOT_AUTHORIZED = 'USER_NOT_AUTHORIZED',
}
